export const isVideoReadyForDraw = (video: Maybe<HTMLVideoElement>): video is HTMLVideoElement => {
    if (!video) {
        return false;
    }

    return video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && video.videoWidth > 0 && video.videoHeight > 0;
};
